// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"0f9d0cb8","30":"c5fd0771","133":"6b89af49","141":"61ed66af","357":"7b021474","629":"938bfd36","633":"1e522b2a","637":"36c45389","664":"ee15e0e4","696":"15c899e4","831":"3aaa5753","885":"19d9c894","896":"9969cdc7","906":"46d45d43","928":"84c45aab"}[chunkId] + ".chunk.js";
};